export default __webpack_public_path__ + "static/media/DK_Layout_2.302a1f27.png";